import cmsApi from '@src/services/cms-api';
import { MESSAGE_CMS_ID } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

const Service = {
  getServiceAsync: () => cmsApi.getArticleList({ categoryId: MESSAGE_CMS_ID[getLanguageByPath()], pageNum: 1, pageSize: 9999, moreInfo: 1 })
};
export default Service;
